import { Badge, Paper, Table, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

import type { TeamDailyBudget } from "@msc/shared";

const eur = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0,
});

/** Restbudgets der Serviceprojekte des Bereichs — informativ, read-only. */
export function BudgetTable({ budgets }: { budgets: TeamDailyBudget[] }) {
  const { t } = useTranslation();
  if (budgets.length === 0) return null;

  return (
    <Paper withBorder p="md">
      <Text fw={600} mb="sm">
        {t("pages.teamDaily.budgets")}
      </Text>
      <Table.ScrollContainer minWidth={520}>
        <Table striped highlightOnHover>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>{t("pages.teamDaily.project")}</Table.Th>
              <Table.Th>{t("common.customer")}</Table.Th>
              <Table.Th ta="right">{t("pages.teamDaily.budgetLeft")}</Table.Th>
              <Table.Th>{t("common.actions")}</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {budgets.map((b) => {
              const low = b.budgetLeftEur !== null && b.budgetLeftEur <= 0;
              return (
                <Table.Tr key={`${b.projectNumber}-${b.title}`}>
                  <Table.Td>
                    <Text size="sm" fw={500}>
                      {b.projectNumber}
                    </Text>
                    <Text size="xs" c="dimmed" lineClamp={1}>
                      {b.title}
                    </Text>
                  </Table.Td>
                  <Table.Td>{b.customerName ?? "—"}</Table.Td>
                  <Table.Td ta="right">
                    <Text size="sm" c={low ? "red" : undefined} fw={low ? 700 : 400}>
                      {b.budgetLeftEur === null ? "—" : eur.format(b.budgetLeftEur)}
                    </Text>
                  </Table.Td>
                  <Table.Td>
                    <Badge size="xs" variant="light">
                      {b.status}
                    </Badge>
                  </Table.Td>
                </Table.Tr>
              );
            })}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </Paper>
  );
}
